export default __webpack_public_path__ + "static/icon1@2x-bd605f7a52a97b518dc35ec123361345.png";